import * as Sentry from '@sentry/browser';
import settings from '@/settings';

if (import.meta.env.MODE === 'production') {
    Sentry.init(settings.sentry);
} else if (import.meta.env.MODE !== 'test') {
    // Worth saying in a browser, but it would only be noise in a test run.
    console.log('Vite Mode:', import.meta.env.MODE);
    console.log('Not initializing Sentry');
}
